import Vue from 'vue';
const R = Vue.$R;

export const isNillOrEmpty = R.anyPass([R.isNil, R.isEmpty]);
